import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ITransferAddEditRequest } from '../../../../model/sge/transfer/request/transfer-add-edit-request';
import { ITransferPagedRequest } from '../../../../model/sge/transfer/request/transfer-paged-request';
import { ITransferResponse } from '../../../../model/sge/transfer/response/transfer-response';

const basePath = (amendmentId: number) => `Amendment/${amendmentId}/Transfers`;

const list = async (amendmentId: number, params: Omit<ITransferPagedRequest, 'amendmentId'>): Promise<Pagination<ITransferResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(amendmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<ITransferResponse>(), response.data));
};

const getById = async (amendmentId: number, id: number): Promise<ITransferResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(amendmentId)}/${id}`
    }).then((response) => response.data);
};

const add = async (amendmentId: number, params: ITransferAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${basePath(amendmentId)}`,
        data: params
    });
};

const edit = async (amendmentId: number, id: number, params: ITransferAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${basePath(amendmentId)}/${id}`,
        data: params
    });
};

const remove = async (amendmentId: number, id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${basePath(amendmentId)}/${id}`
    });
};

const TransferAppService = { list, getById, add, edit, remove };
export default TransferAppService;
